module.exports = __webpack_public_path__ + "static/media/about1.7c256c9c.jpg";